import styled from '@rsos/theme/styled';

export const StyledDebugMenu = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 8px 17px;
  align-items: center;
  background-image: ${({ theme }) => {
    const a = theme.colors.foreground;
    const b = theme.colors.background;
    return `linear-gradient(45deg, ${a} 25%, ${b} 25%, ${b} 50%, ${a} 50%, ${a} 75%, ${b} 75%, ${b} 100%)`;
  }};
  background-size: 50px 50px;
  box-shadow:
    0 2px 5px -2px rgba(0, 0, 0, 0.1),
    inset 0 2px 5px -2px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  > :first-child {
    flex-grow: 1;
  }
`;
